import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { AvailableReactionType } from "./AvailableReactionType.jsx";
import { InitialReaction } from "./InitialReaction.jsx";
import { useToggleReaction } from "./useToggleReaction.jsx";
import { getAvailableReactionTypes } from "../../store/selectors/selector.reactions.jsx";

export const ReactionTypesPalette = ({ parentType, parentId, className, onClick }) => {
  const reactionTypes = useSelector(getAvailableReactionTypes);
  const toggleReaction = useToggleReaction(parentType, parentId);

  const handleClick = useCallback(
    (type) => {
      toggleReaction(type);
      typeof onClick === "function" && onClick();
    },
    [onClick, toggleReaction]
  );

  return (
    <div className={className}>
      <InitialReaction />
      {reactionTypes.map((reactionType, index) => (
        <AvailableReactionType
          key={index}
          type={reactionType}
          parentType={parentType}
          parentId={parentId}
          onClick={handleClick}
        />
      ))}
    </div>
  );
};

ReactionTypesPalette.propTypes = {
  parentType: PropTypes.string,
  parentId: PropTypes.number,
  className: PropTypes.string,
  onClick: PropTypes.func,
};
